(function () {
  const initSlider = (section) => {
    const box = section.querySelector(".multicolumn");
    const slider = section.querySelector(".swiper--multicolumn");

    if (!slider) return;

    // Don't reinitialize if already initialized
    if (slider.swiper) return;

    const slides = slider.querySelectorAll(".multicolumn-card");

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const nextBtn = box.querySelector(".multicolumn__navigation-button-next");
    const prevBtn = box.querySelector(".multicolumn__navigation-button-prev");

    new Swiper(slider, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 8,
      speed: 800,
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      }
    });
  };

  const destroySlider = (section) => {
    const slider = section.querySelector(".swiper--multicolumn");
    const slides = section.querySelectorAll(".multicolumn-card");

    if (slider?.swiper) slider.swiper.destroy();

    slides.forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove("swiper-slide");
    });
  };

  const initMulticolumn = (section) => {
    if (!section || !section?.classList.contains("multicolumn-section")) return;

    const box = section.querySelector(".multicolumn");

    if (!box) return;

    // Always initialize the slider regardless of screen size
    initSlider(section);
  };

  initMulticolumn(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initMulticolumn(event.target);
  });
})();